import { List, Record } from "immutable";
import { PriceListProcessRecords, fromJSON } from "common/records/PriceListProcess";
import { RootActions, RootState } from "common/reducers";
import { FETCH_PROCESSES, RECEIVE_PROCESSES, RECEIVE_PROCESS_ERRORS } from "common/reducers/priceListProcess.actions";

export const PriceListProcessStateRecord = Record({
  processes: new PriceListProcessRecords(),
});

export const initialState = PriceListProcessStateRecord();
export type PriceListProcessState = typeof initialState;

export const reducer = (state: RootState, action: RootActions): RootState => {
  let processes: PriceListProcessRecords;
  switch (action.type) {
    case FETCH_PROCESSES:
      if (state.getIn(["priceListProcesses", "processes"])) {
        return state.setIn(["priceListProcesses", "processes", "loading"], true);
      }
      return state.setIn(["priceListProcesses", "processes"], fromJSON({ list: {}, loading: true }));
    case RECEIVE_PROCESSES:
      processes = fromJSON({ ...action.payload, loading: false });

      return state.setIn(["priceListProcesses", "processes"], processes);
    case RECEIVE_PROCESS_ERRORS:
      return state
        .setIn(["priceListProcesses", "processes", "errors"], List<string>(action.payload))
        .setIn(["priceListProcesses", "processes", "loading"], false);
    default:
      return state;
  }
};
